import RoasGraph from "@/components/brand_portfolio/RoasGraph";
import { EvolutionChartEngine } from "@/utils/dashboard/chart_engine";
export default {
  name: "Roas",
  components: {
    RoasGraph
  },
  props: {
    roasData: {
      type: Array,
      default: [],
      required: true
    },
    periodLength: {
      type: Number,
      default: 14
    },
    selected_period: {
      type: String,
      default: "14 days"
    },
    workspace_id: {
      type: String,
      default: ""
    },
    seller_id: {
      type: String,
      default: ""
    },
    hovering_workspace_id: {
      type: String,
      default: ""
    },
    hovering_seller_id: {
      type: String,
      default: ""
    },
    hovering_index: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      chartEngine: null,
      defaultData: {
        label: null,
        evol_value: 0,
        kpi_value: 0
      }
    };
  },
  computed: {
    lastestValue() {
      return this.roasData?.[0]?.ROAS?.toFixed(2) ?? "-";
    },
    computedTextClass() {
      return this.roasData.length == 0 || this.roasData[0]?.roas_evol_vs_previous_period == 0 ? "gray" : this.roasData[0]?.roas_evol_vs_previous_period > 0 ? "green" : "red";
    },
    computedRoasData() {
      return [...this.roasData].reverse();
    },
    computedBottomPosition() {
      const roasValue = this.computedRoasData.map(value => value.ROAS);
      const highestRoasValue = Math.max(...roasValue);
      const bottomPos = 1 / highestRoasValue * 80;
      console.log("botpos", bottomPos);
      return {
        "bottom": `${-15 + bottomPos}px`
      };
    }
  },
  methods: {}
};